import axios from './configObra/config-obra';

const defaultRoute = '/unidades';

export default {
    list: () => axios.get(`${defaultRoute}`),
    create: (unidades) => axios.post(defaultRoute, unidades),
    update: (id, unidades) => axios.patch(`${defaultRoute}/${id}`, unidades),
    remove: (id) => axios.delete(`${defaultRoute}/${id}`)
}
